import {randomId,View} from "vritra";
import css from "./ItemView.module.css";


export default function ItemView(props){
    const {parent,id=randomId("itemview"),item,index}=props;
    const itemview=View({parent,id,className:`${css.itemview} ${props.className||""}`});

    itemview.innateHTML=`
        <p class="${css.name}">${item?.name||`item N°${index+1}`}</p>
    `;

    return itemview;
}
